module.exports = __webpack_public_path__ + "static/media/banner1.792e084f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/supplier/loewer/images/banner1.jpg
// module id = 522
// module chunks = 0